const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_MINUTE = 60;
const SECONDS_PAD_LENGTH = 2;
const ZERO_DURATION = '0:00';

export const formatDurationSeconds = (totalSeconds: number): string => {
    const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
    const minutes = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);

    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};

export const formatMinutesSeconds = (totalSeconds: number): string => {
    if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) {
        return ZERO_DURATION;
    }

    const wholeSeconds = Math.round(totalSeconds);
    const minutes = Math.floor(wholeSeconds / SECONDS_PER_MINUTE);
    const seconds = wholeSeconds % SECONDS_PER_MINUTE;
    const paddedSeconds = seconds.toString().padStart(SECONDS_PAD_LENGTH, '0');

    return `${minutes}:${paddedSeconds}`;
};
